module.exports = "<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>"